import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Clients from '../components/Clients';
import Contact from '../components/Contact';
import { setPageMeta } from '../utils/seo';

const Home = () => {
  useEffect(() => {
    setPageMeta(
      'HRCONSOL - Redefining HR Solutions',
      'Executive search, tech recruitment, RPO, payroll outsourcing, OD consultancy, training solutions and more for future-ready organizations.'
    );
  }, []);

  return (
    <>
      <Hero />
      <Services />
      <About />
      <Clients />
      <Contact />
    </>
  );
};

export default Home; 